import api, { unwrap } from './client';
import type { ApiResponse } from '@/types/api';
import type { PageResponse } from '@/types/api';
import type {
  BillingModulePlanResponse,
  BillingModuleSubscriptionResponse,
  BillingOverviewResponse,
  BillingUsageMeterResponse,
  UsageMetricLedgerResponse,
} from '@/types/platformBilling';

export const platformBillingApi = {
  overview: () =>
    unwrap(api.get<ApiResponse<BillingOverviewResponse>>('/v1/platform/billing/overview')),

  modules: () =>
    unwrap(api.get<ApiResponse<BillingModuleSubscriptionResponse[]>>('/v1/platform/billing/modules')),

  modulePlans: (moduleCode: string) =>
    unwrap(
      api.get<ApiResponse<BillingModulePlanResponse[]>>(
        `/v1/platform/billing/modules/${encodeURIComponent(moduleCode)}/plans`,
      ),
    ),

  activateModule: (moduleCode: string, planCode: string) =>
    unwrap(
      api.post<ApiResponse<BillingModuleSubscriptionResponse>>(
        `/v1/platform/billing/modules/${encodeURIComponent(moduleCode)}/activate`,
        { planCode },
      ),
    ),

  usage: () =>
    unwrap(api.get<ApiResponse<BillingUsageMeterResponse[]>>('/v1/platform/billing/usage')),

  usageLedger: (params?: { moduleCode?: string; metricCode?: string; page?: number; size?: number }) =>
    unwrap(
      api.get<ApiResponse<PageResponse<UsageMetricLedgerResponse>>>('/v1/platform/billing/usage/ledger', {
        params,
      }),
    ),
};
